// extracted by mini-css-extract-plugin
var _1 = "Activities_comments__x2RjP";
export { _1 as "comments" }
